var $ = require('jquery');

var footer = {
  init: function (blockId:string) {
    var $holder = $('#' + blockId),
        $dealerList;

    if ($holder.length) {
      $dealerList = $holder.find('#' + blockId + '__dealer-select');
      //console.log('footer found');
      //console.log($dealerList);
      $dealerList.on('change', function(e) {
        //console.log('dealer changed');
        e.preventDefault();

        window.location = $dealerList.val();

      })
    }
  }
};

export { footer };
